import React, { Component } from "react";
import DashboardContent from '../FunctionComponents/Dashboard/DashboardContent';

class Dashboard extends Component {
  render() {
    return (
      <div>
        < DashboardContent />
      </div>
    );
  }
}

export default Dashboard;
